// extracted by mini-css-extract-plugin
export default {"container":"Messages_container__YX3oy"};